import createReactComponent from '../createReactComponent';
export default createReactComponent('radar', 'IconRadar', [
  ['path', { d: 'M21 12h-8a1 1 0 1 0 -1 1v8a9 9 0 0 0 9 -9', key: 'svg-0' }],
  ['path', { d: 'M16 9a5 5 0 1 0 -7 7', key: 'svg-1' }],
  ['path', { d: 'M20.486 9a9 9 0 1 0 -11.482 11.495', key: 'svg-2' }],
]);
